import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';

export const WorkCard = ({ work, onOpen, className = '' }) => (
  <motion.button
    data-testid={`work-card-${work.id}`}
    onClick={() => onOpen?.(work)}
    className={`group relative block w-full text-left bg-ink ${className}`}
    whileHover={{ y: -6 }}
    transition={{ duration: 0.3, ease: 'easeOut' }}
  >
    <div className="relative overflow-hidden clip-corner aspect-[4/3]">
      <img
        src={work.image}
        alt={`${work.client} — ${work.title}`}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/15 to-transparent opacity-85 group-hover:opacity-95 transition-opacity duration-500" />
      <div className="absolute top-4 left-4">
        <span className="bg-butter text-ink text-[11px] font-bold uppercase tracking-[0.15em] px-3 py-1.5 border border-ink">
          {work.category}
        </span>
      </div>
      <div className="absolute bottom-0 inset-x-0 p-5 sm:p-7 flex items-end justify-between gap-4">
        <div>
          <p className="text-cream/70 text-[11px] uppercase tracking-[0.22em] mb-1.5">
            {work.client} — {work.year}
          </p>
          <h3 className="font-slab font-bold text-cream text-xl sm:text-2xl leading-tight">{work.title}</h3>
        </div>
        <span className="shrink-0 w-11 h-11 rounded-full bg-butter text-ink flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
          <ArrowUpRight size={18} />
        </span>
      </div>
    </div>
  </motion.button>
);
